import { render, staticRenderFns } from "./OAlert.vue?vue&type=template&id=c7cfc60c&"
import script from "./OAlert.vue?vue&type=script&lang=js&"
export * from "./OAlert.vue?vue&type=script&lang=js&"
import style0 from "./OAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports